'use strict';


/**
 * @author Maxim Seredkin
 */
export default ['$resource', function($resource) {
    return $resource('https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party', null, {
        findByInn: {
            method: 'POST',
            headers: {
                'Authorization': 'Token ' + DA_DATA_API_TOKEN,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            withCredentials: false,
        },
    });
}];
